import { memo } from 'react';
import { StackItem, TextStyle, Typography } from '@optimus-web/core';
import { LocalizedCurrencyValue, LocalizedPercentage, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Amount } from '@mews-commander/data-access';

export enum ViewMode {
    Percentage = 'percentage',
    Currency = 'currency',
}

export interface AgeingData {
    percentage?: number | null;
    currency?: Amount | null;
}

interface AgeingItemProps {
    daysAging: string;
    value: AgeingData;
    view: ViewMode;
    isCompactMode: { showSymbol: boolean; precision: number; textStyle: TextStyle };
}

export const AgeingItem: React.FC<AgeingItemProps> = memo(({ daysAging, value, view, isCompactMode }) => {
    const { percentage, currency } = value;
    return (
        <StackItem>
            <Typography textStyle={isCompactMode?.textStyle ?? 'highlightSmall'} as="div">
                {view === ViewMode.Percentage ? (
                    <LocalizedPercentage value={(percentage ?? 0) / 100} />
                ) : (
                    <LocalizedCurrencyValue
                        value={currency}
                        options={{ showSymbol: isCompactMode.showSymbol, precision: isCompactMode.precision }}
                    />
                )}
            </Typography>
            <Typography textStyle="bodySmall" variant="tertiary" as="div">
                <LocalizedText textKey={TextKey.DayCount} substitutes={{ count: daysAging }} />
            </Typography>
        </StackItem>
    );
});
